import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log('SetSurveyAnswer', payload);
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'SetSurveyAnswer',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {
                    answer: payload.answer,
                },
                urlArgs: {
                    question_id: payload ? payload.question_id : null,
                },
            });

            // We will only get something in the result if the request failed.
            if (result.length) {
                return {
                    ...result,
                    success: false,
                    isError: true,
                    error: result.data ? result.data : result,
                };
            } else {
                return {
                    ...result,
                    isError: false,
                    error: {},
                    answer: payload.answer ? payload.answer : '',
                    question_id: payload.question_id ? payload.question_id : null,
                };
            }
        } else {
            return {};
        }
    };
};
